export enum ShipperPortalModuleConfigurationType {
  order = 'SHIPPER_APP_ORDER_CONFIGURATION',
  customer = 'SHIPPER_APP_CUSTOMER_CONFIGURATION',
  payment = 'SHIPPER_APP_PAYMENT_CONFIGURATION'
}
